import React from 'react';
import {ButtonWithDropdown, NavbarWithDropdown} from '@components';

const AnimationPage = () => {

    const navbarDropdownItems = [
        { label: '링크없음' },
        { label: '링크 존재', href: '/another-action' },
    ];

    const buttonDropdownItems = [
        { label: '링크 없음' },
        { label: '링크 존재', href: '/another-action' },
        { label: '테스트', href: '/something-else' },
    ];

  return (
    <>
        <h1 className="h3 mb-1 text-gray-800">Animation Utilities</h1>

        <div className="row">

            <div className="col-lg-6">

                <div className="card position-relative">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">카드 제목</h6>
                    </div>
                    <div className="card-body">
                    <NavbarWithDropdown
                        brand="테스트"
                        dropdownLabel="보기"
                        dropdownItems={navbarDropdownItems}
                    />
                        <p className="mb-0 small"> 카드 설명 란</p>
                    </div>
                </div>

            </div>

            <div className="col-lg-6">

                <div className="card position-relative">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">카드제목</h6>
                    </div>
                    <div className="card-body">
                    <ButtonWithDropdown
                        buttonLabel="드롭다운"
                        dropdownItems={buttonDropdownItems}
                    />
                    </div>
                </div>

            </div>
            

        </div>


    </>
  );
};

export {AnimationPage};
